<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="piece_work"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="description"
                        sub-line-key="rate"
                        v-model="selectedPieceID"
                        filterLabel="Filter Piecework"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createPieceShow = !createPieceShow"
                        >
                            <v-icon left>mdi-account-tie</v-icon>
                            Add Piecework
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedPiece">
                <v-card>
                    <modify-piece :edit-piece="selectedPiece" @save="upsertPiece($event)"/>
                </v-card>
                <v-card class="mt-2">
                    <div class="primary d-flex align-center">
                        <div class="flex-grow-1 primary pl-3 pr-2 sub--text">
                            {{selectedPiece.description || 'Piecework'}} Barcodes
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <manage-barcodes ref-key="fkPieceWork" :ref-val="selectedPiece.id"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createPieceShow"
                    v-model="createPieceShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <modify-piece :edit-piece="createPieceObj" @dismiss="createPieceShow = !createPieceShow" @save="upsertPiece($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyPiece from "./ModifyPiece";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ManageBarcodes from "../Manage Barcodes/ManageBarcodes";

export default {
    components: {
        ManageBarcodes,
        Divider,
        ModifyPiece,
        MultiSelectList
    },
    props: {},
    data() {
        return {
            selectedPieceID: null,
            createPieceObj: null,
            createPieceShow: false,
        }
    },
    watch: {
        createPieceShow(val) {
            if (val)
                this.createPieceObj = {
                    id: null,
                    description: null,
                    rate: 0,
                    fkFarm: null,
                    type: 0,
                    unitDescription: null,
                    startTime: '08:00',
                    endTime: '17:00'
                }
        }
    },
    methods: {
        async upsertPiece(event) {
            console.log(event)
            let {emp, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/piece`, emp)
                const addedPieceID = (await waitForEvent(eventID)).piece_work.pop().id
                this.createPieceShow = false
                this.selectedPieceID = addedPieceID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['piece_work', 'farms']),
        selectedPiece() {
            if (!this.selectedPieceID)
                return null
            return this.piece_work.filter(obj => obj.id === this.selectedPieceID).pop()
        },
    },
}
</script>

<style scoped>

</style>